<h2 *ngIf="item.list_label && item.list_label.length > 0">{{item.translation_key_list_label||item.list_label| translation|translationFromString | transformText :item?.text_transform_list_label}}</h2>
<div class="align-center fa-2x" *ngIf="view && loading">
  <scaffold-loading-animation></scaffold-loading-animation></div>
  <div class="card-index-list" [ngClass]="{'has-active-card':active >= 0}">
    <div class="card-index-item show-display-view" *ngFor="let ite of view; let $i = index" [style]="(active >= 0 ? (active != $i ? ('padding-top:' + ($i > active ? ( ($i-active) * 70 ):($i * 70)) + 'px;') : 'margin-left:30px;') : '')|safeStyle" [ngClass]="{'active-card':active == $i}">
      <div class="card-index-item-head">
        <span class="pull-right" *ngIf="active == $i" (click)="selectItem($i)" [title]="'close_module'| translation">
          <i class="fas fa-times"></i>
        </span>
        <div class="card-index-item-title" *ngIf="active >= 0 && active != $i" (click)="selectItem($i)">{{item.translation_key_tab_label||item.tab_label| translation|translationFromString | transformText :item?.text_transform_tab_label}} {{$i + 1}}</div>

      </div>
      <div class="card-index-item-list">

        <div class="card-index-item-content" (click)="selectItem($i)">
          <app-rendered *ngFor="let it of ite.data.content; let $ci = index" [childview]="ite.childview || []" [paramprefix]="item.paramprefix" [info]="ite" [item]="it" [arr]="ite.data.content" [data]="item_data[$i]" [indexActive]="active >= 0 ? active == $i: undefined"></app-rendered>
        </div>

      </div>

      <div class="card-index-display">

        <div>
          <app-rendered [info]="ite" *ngFor="let it of item.content" [paramprefix]="item.paramprefix" [item]="it" [arr]="item.content" [data]="data"></app-rendered>
        </div>
        <h3 *ngIf="displayItem && displayItem.item && displayItem.item.card_label">{{displayItem.item.card_label}}</h3>
        <div *ngIf="!item.tab_view" style="align-content:flex-end;">
          <div class="card-display-list-item" *ngFor="let it of display_view[$i];trackBy: trackByFn; let $ind = index">
            <app-view [info]="it" *ngIf="it && it.data" [childview]="it.childview || []" [items]="it.data.content" [data]="display_item_data[$ind]"></app-view>
          </div>
          <button nbButton status="primary" *ngIf="displayItem" style="border: 1px solid #999;min-width: 10px;" [title]="getTitle(displayItem.item.card_label)" (click)="createData()" [disabled]="checkDisable()"><i class="fas fa-plus"></i></button>
        </div>
        <div *ngIf="item.tab_view">
          <nb-tabset>
            <nb-tab *ngFor="let ite of display_view[$i];trackBy: trackByFn; let $i = index" tabTitle="{{ite.title}}">
              <div *ngIf="item.inline_create && view.length == 0">
                <button nbButton status="primary" *ngIf="checkKeys(item_data[$i])" (click)='save(item_data[$i],ite)' [disabled]="hasErrors(item_data[$i]) || checkDisable()">{{'create'| translation}}</button>
              </div>
              <app-view [info]="ite" *ngIf="ite && ite.data" [childview]="ite.childview || []" [items]="ite.data.content" [data]="item_data[$i]" (deleteDataEvent)="deleteHandler($event)" (openViewHandler)="openViewHandler($event, ite)" (openLinkHandler)="openLinkHandler($event, ite)"></app-view>
            </nb-tab>
          </nb-tabset>
          <button nbButton color="primary" *ngIf="displayItem" style="border: 1px solid #999;min-width: 10px;" [title]="getTitle(displayItem.item.card_label)" (click)="createData()" [disabled]="checkDisable()"><nb-icon pack="fas" icon="plus"></nb-icon></button>

        </div>
      </div>
    </div>
  </div>
